"use client";
import { useDefaultView } from "../DefaultViewContext";
import {
  IconButton,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";

import styles from "./DefaultViewButton.module.css";

const DefaultViewButton = () => {
  const { handleResetDefaultView, handleSaveDefaultView, isButtonsDisabled } =
    useDefaultView();

  return (
    <>
      {isButtonsDisabled ? (
        <div className={styles.disabledButtons}>
          <Tooltip
            allowMultiline={true}
            content={"This is your current default view"}
            key={"save-as-default-view-button"}
            placement="bottom"
          >
            <TooltipFocusableTrigger>
              <IconButton
                aria-label="Save as default view"
                size="medium"
                name="actionBookmark"
                variant="tertiary"
                onPress={undefined}
                isDisabled={isButtonsDisabled}
                style={{
                  borderRight: "none",
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
            </TooltipFocusableTrigger>
          </Tooltip>
          <Tooltip
            allowMultiline={true}
            content={"This is your current default view"}
            key={"reset-default-view-button"}
            placement="bottom"
          >
            <TooltipFocusableTrigger>
              <IconButton
                aria-label="Reset default view"
                size="medium"
                name="arrowRefresh"
                variant="tertiary"
                onPress={undefined}
                isDisabled={isButtonsDisabled}
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              />
            </TooltipFocusableTrigger>
          </Tooltip>
        </div>
      ) : (
        <div className={styles.enabledButtons}>
          <Tooltip
            allowMultiline={true}
            content={"Save as default view"}
            key={"save-as-default-view-button"}
            placement="bottom"
          >
            <TooltipFocusableTrigger>
              <IconButton
                aria-label="Save as default view"
                size="medium"
                name="actionBookmark"
                variant="tertiary"
                onPress={handleSaveDefaultView}
                style={{
                  borderRight: "none",
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
            </TooltipFocusableTrigger>
          </Tooltip>
          <Tooltip
            allowMultiline={true}
            content="Return to default view"
            key="return-to-default-view-button"
            placement="bottom"
          >
            <TooltipFocusableTrigger>
              <IconButton
                aria-label="Reset default view"
                size="medium"
                name="arrowRefresh"
                variant="tertiary"
                onPress={handleResetDefaultView}
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              />
            </TooltipFocusableTrigger>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default DefaultViewButton;
